import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import classes from './CoevaluationItem.module.css';

const CoevaluationItem = props => {
  const { t } = useTranslation(['lesson']);
  const rubric = [
    { value: 1, text: t('option_1') },
    { value: 2, text: t('option_2') },
    { value: 3, text: t('option_3') },
    { value: 4, text: t('option_4') },
    { value: 5, text: t('option_5') }
  ];
  const [value, setValue] = useState(props.coevaluation.value);

  const handleChangeItem = event => {
    props.coevaluationActivity(
      props.coevaluation.coevaluationOrder,
      Math.pow(5, event.target.value) *
        props.coevaluation.idCoevaluationItem
    );
    setValue(event.target.value);
  };

  return (
    <>
      <p className={classes.coevaluationItem}>
        {props.coevaluation.coevaluationOrder}.-{' '}
        {props.coevaluation.item}
      </p>
      <TextField
        variant="outlined"
        select
        disabled={props.notCoeval}
        label={!props.notCoeval ? t('select_an_option') : null}
        className={classes.textField}
        onChange={handleChangeItem}
        SelectProps={{
          MenuProps: {
            className: classes.menu
          }
        }}
        InputLabelProps={{
          shrink: true
        }}
        value={value}
      >
        {rubric.map(option => {
          return (
            <MenuItem
              key={option.value}
              value={option.value}
              className={classes.optionItem}
            >
              {option.text}
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
};

CoevaluationItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  notCoeval: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  coevaluation: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  coevaluationActivity: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  idCoevaluationItem: PropTypes.array
};

export default CoevaluationItem;
